import React from 'react';
export var getCustomArrowsRenderer = function (options) {
    var shouldUseCustomArrows = options.shouldUseCustomArrows, isArrowPrivateMedia = options.isArrowPrivateMedia, customArrowsSvg = options.customArrowsSvg, customArrowsRotation = options.customArrowsRotation;
    if (!shouldUseCustomArrows) {
        return null;
    }
    return function (position) {
        var dir = position === 'right' ? 1 : -1;
        var style = {
            transform: "rotate(".concat(customArrowsRotation * dir, "deg) scaleX(").concat(dir, ")"),
            transformOrigin: 'center',
            height: '100%',
            width: '100%',
            display: 'block',
        };
        if (isArrowPrivateMedia) {
            return (React.createElement("img", { style: style, src: customArrowsSvg, alt: "gallery navigation arrow" }));
        }
        else {
            return (React.createElement("span", { style: style, className: "custom-nav-arrows", dangerouslySetInnerHTML: { __html: customArrowsSvg } }));
        }
    };
};
//# sourceMappingURL=customArrowsRenderer.js.map